// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AgentInfo = require("../../common/Components/AgentInfo.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let TerminatedAgentIconOverlay = require("../../common/Components/TerminatedAgentIconOverlay.bs.js");
let ClientPageMatchCardAgent_agent_graphql = require("../../../__generated__/ClientPageMatchCardAgent_agent_graphql.bs.js");

let convertFragment = ClientPageMatchCardAgent_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ClientPageMatchCardAgent_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ClientPageMatchCardAgent_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ClientPageMatchCardAgent_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ClientPageMatchCardAgent_agent_graphql.node, convertFragment, fRef);
}

let Fragment_membershipStatusV5_decode = ClientPageMatchCardAgent_agent_graphql.Utils.membershipStatusV5_decode;

let Fragment_membershipStatusV5_fromString = ClientPageMatchCardAgent_agent_graphql.Utils.membershipStatusV5_fromString;

let Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ClientPageMatchCardAgent(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "xSmall";
  let agent = RescriptRelay_Fragment.useFragment(ClientPageMatchCardAgent_agent_graphql.node, convertFragment, props.agent);
  let match = agent.membershipStatus;
  if (match === "TERMINATED") {
    return JsxRuntime.jsx(TerminatedAgentIconOverlay.make, {
      size: size,
      children: JsxRuntime.jsx(AgentInfo.Presentation.make, {
        avatar: AvatarSrcUrl.place_holder,
        size: size,
        name: agent.displayName,
        brokerage: "NO LONGER ON TAN"
      })
    });
  }
  let match$1 = agent.profilePhoto;
  let avatar = match$1 !== undefined ? match$1.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo.Presentation.make, {
    avatar: avatar,
    size: size,
    name: agent.displayName,
    brokerage: agent.brokerage,
    wrapName: name => JsxRuntime.jsx(ButtonsV5.Link.make, {
      href: `/agents/` + agent.id,
      onClick: e => {
        e.stopPropagation();
      },
      children: JsxRuntime.jsx("div", {
        children: name,
        className: "font-medium"
      })
    }),
    children: null
  });
}

let make = ClientPageMatchCardAgent;

exports.Fragment = Fragment;
exports.make = make;
/* AgentInfo Not a pure module */
